module.exports = __webpack_public_path__ + "img/about-banner.de0d257d.png";